import { getViewerFor } from 'Cloud/ui/Viewer/viewerFactory';
import localState from 'lib/store';
import React, { useMemo, useState, VFC } from 'react';
import { useSelector } from 'react-redux';
import { getFeatureMyOfficePromoRating, getFeatureMyOfficeViewerPromo } from 'reactApp/modules/features/features.selectors';
import { CloudFile } from 'reactApp/modules/storage/storage.types';
import { MyOfficePopup } from 'reactApp/ui/MyOfficePromo/Popup/MyOfficePopup';
import { ViewerSnackbar } from 'reactApp/ui/MyOfficePromo/ViewerSnackbar/ViewerSnackbar';
import opener from 'reactApp/utils/opener';

const RADAR_NAME = 'myoffice-viewer-promo';
const SESSION_STORAGE_VIEW_KEY = RADAR_NAME;

/**
 * Если с момента скрытия показа плашки прошло больше 30 дней, то показываем ее еще раз
 * Значение hideDays может быть взято из конфига
 * @param hideDays
 */
const isSnackbarAlreadyVisible = (hideDays = 30) => {
    const visibleTime = localState.get(SESSION_STORAGE_VIEW_KEY);
    if (!visibleTime) {
        return false;
    }
    const passedDays = (new Date().getTime() - parseInt(visibleTime)) / 1000 / 60 / 60 / 24;

    return passedDays < hideDays;
};

interface IViewerSnackbarPromoContainerProps {
    isAttaches: boolean;
    file: CloudFile;
}

export const ViewerSnackbarPromoContainer: VFC<IViewerSnackbarPromoContainerProps> = ({ isAttaches, file }) => {
    const featureData = useSelector(getFeatureMyOfficeViewerPromo);
    const showPromoRating = useSelector(getFeatureMyOfficePromoRating);
    const viewerApi = useMemo(() => getViewerFor(file.ext, isAttaches), [file.ext, isAttaches]);
    const [visible, setVisible] = useState(() => viewerApi.isMyOffice && !!featureData && !isSnackbarAlreadyVisible(featureData?.hideDays));

    return visible ? (
        <MyOfficePopup
            radarName={RADAR_NAME}
            offset={[-30, 5]}
            position="top center"
            mouseLeaveDelay={featureData?.mouseLeaveDelay}
            mouseEnterDelay={featureData?.mouseEnterDelay}
        >
            <ViewerSnackbar
                showPromoRating={showPromoRating}
                radarName={RADAR_NAME}
                onClickAd={() => {
                    if (featureData?.adLink) {
                        opener(featureData.adLink);
                    }
                }}
                onClick={() => {
                    if (!isAttaches && featureData?.cloudLink) {
                        opener(featureData.cloudLink);
                    } else if (featureData?.attachLink) {
                        opener(featureData.attachLink);
                    }
                }}
                onClickClose={() => {
                    setVisible(false);
                    localState.set(SESSION_STORAGE_VIEW_KEY, `${new Date().getTime()}`);
                }}
            />
        </MyOfficePopup>
    ) : null;
};
